import Tabbar from '@/components/Tabbar'
import { mapActions } from 'vuex'
import commonMixin from '@/mixin/common'
export default {
  name: 'LoginPage',
  data () {
    return {
      form: {
        phone: null,
        password: null,
        code: null
      },
      loading: false
    }
  },
  mixins: [commonMixin],
  components: {
    Tabbar
  },
  methods: {
    ...mapActions ({
      USER_LOGIN: 'USER_LOGIN'
    }),
    onLogin () {
      let phone = this.form.phone
      let password = this.form.password
      if (!phone) {
        this.error('请正确填写手机号')
        return false
      }
      if (!password) {
        this.error('请正确填写密码')
        return false
      }
      let data = {
        phone: this.form.phone,
        password: this.form.password,
      }
      this.loading = true
      this.USER_LOGIN(data).then(res => {
        this.loading = false
        this.success('登陆成功')
        this.$router.push({name: 'user'})
      }).catch(err => {
        this.loading = false
        try {
          this.error(err.message)
        } catch (e) {
          this.error(e.message)
        }
      })
    },
    reset () {
      this.form = {
        phone: null,
        password: null,
        code: null
      }
      this.loading = false
    },
    handleRoute (route) {
      if (route.name === 'login') {
        this.reset()
      }
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}